export const styles = {
  style: {
    flexDirection: "row"
  },
  avatar: {
    margin: 6
  }
};
